/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
export default {
  name: "stats",
  components: {
    Multiselect
  },
  props:{
    id:{
      type:String,
      default:""
    },
    editoption:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      programName: "",
      rowFieldName: "",
      groupByField: "",
      returnType: "",
      orientation: "",
      pageGroup: "",
      reportName:"",
      reportId:"",
      developerName:"",
      qcName:"",
      status:"",
      programId:"",
      tocId:"",
      rowFilters: [],
      rowFilterFields: [],
      categoricalFields: [],
      numericalFields: [],
      columnFilters: [],
      columnFiltersValues:[],
      data: [],
      loadingBlock: false,
      loadingSaveBlock:false,
      rowFilterValidations: [],
      dataPages: [],
      numericOperations:[],
      numericOperationValues:[
        {label:"count",value:"count"},
         {label:"mean",value:"mean"},
        {label:"std",value:"std"},
        {label:"min",value:"min"},
        {label:"max",value:"max"}
      ],
      calculationsFilterValidations: [],
      selectedFields: [""],
      rowFilters: [{
        Operator: "",
        ColumnName: "",
        Value: ""
      }
      ],
      calculations: {
      },
      columnFieldNames: [],
      groupByFilter: [],
      chartType: "",
      studyInfo:{},
      editData:{},
      reportType: "",
      graphData: "",
      clickedTab: "",
      footnotes: "",
      displayModal: false,
      showCreate:false,
      setMacro:false,
      counter: 1,
      programName:"",
      tableTitle: "",
      tableSubtitle: "",
      tableGroupBy: [],
      tableRowFilters:[{
        Operator: "",
        ColumnName: "",
        Value: ""
      }],
      tableColumnFieldNames:[],
      tableRowFieldNames:[],
      tableColumnFilters:[],
      tablePageGroup:"",
      tableReturnType:"",
      tableChartType:"",
      tableReportType:"",
      tableOrientation:"",
      validations: [false, false, false, false, false, false, false, false, false, false, false, false, false],
      columnErrorList:[],
      fileName: "",
      fileList: ["LocalStorage/adsl.xlsx", "LocalStorage/adae.xlsx"],
      graphList:[],
      versionList:[],
      fieldValues:[],
      dropdownSelections:{},
      interimVersion:"",
      comments:"",
      mongoCollection:"",
      uniqueField:"",
      userList: [],
      LocationType : "",
      location :"",
      dbDatasets : [],
      fileName : "",
      interimVersions : [],
      selectedIntVersion : "",
      interimVersionFiles :[],
      programType :"",
      isEDC : false,
    }
  },
  watch: {
    rowFilters: {
      handler(newFilters) {
        if (!this.categoricalFields.length && !this.numericalFields.length) return;
        newFilters.forEach((filter, index) => {
          const validOps = this.getOperatorOptions(filter.ColumnName);

          if (!filter.Operator) {
            this.rowFilters[index].Operator = validOps[0] || '==';
          } 
        });
      },
      deep: true,
      immediate: true
    }
  },  
  created() {
    const savedState = localStorage.getItem('showTocCreate');
    const savedMacro = localStorage.getItem('saveMacro');
    if (savedState == 'true' || savedState == true) {
      this.showCreate = true; // Set state to true if saved in localStorage
    } else {
      this.showCreate = false; // Default to false if nothing is in localStorage
    }
    if (savedMacro == 'true' || savedMacro == true) {
      this.setMacro = true; // Set state to true if saved in localStorage
    } else {
      this.setMacro = false;
      this.isEditMode = true; // Default to false if nothing is in localStorage
    }
  },

  async mounted() {
    this.reportName=localStorage.getItem("Reportname")
    this.reportId=localStorage.getItem("Reportid")
    this.tocId=localStorage.getItem("TocId")
    this.interimVersion=store.getters.getVersion
    await this.getstudyinfo()
    // await this.getVersion()
    await this.getUserList();
    const key = "frequency_fields"; // This can be dynamic
    const value = {
      group_by: [],
      frequency_column: [],
      subject_column: []
    };

    // Add the key-value pair to the object
    this.calculations[key] = value;
    if(this.editoption=='1'){
        await this.getData();
        this.status="In Development"
        await this.listDbDatasets();
        await this.listInterimVersions();
        await this.listInterimVersionFiles();
        await this.listFieldNames();
        await this.getFieldValues();
    }
    else{
      this.status="In Development"
    }
    await this.getTOCDatasetConfig()
    await this.getLocationbaseddataset()
  },

  beforeRouteEnter(to, from, next) {
    if (from.name == 'tocgenerate') {
      localStorage.setItem('showTocCreate', 'true');
    } 
    else if(from.name=='Macro_Management')
    {
      localStorage.setItem('saveMacro',true)
    }
    next((vm) => {
      const savedState = localStorage.getItem('showTocCreate');
      if (savedState == 'true' || savedState == true) {
        vm.showCreate = true;
      }
    });
  },
  beforeRouteLeave(to, from, next) {
      localStorage.removeItem('showTocCreate');
      localStorage.removeItem('Reportname');
      localStorage.removeItem('Reportid');
      localStorage.removeItem('TocId');
      localStorage.removeItem('saveMacro');
      next();
  },
  methods: {
    async getLocationbaseddataset()
    {
      if(this.LocationType == 'database')
      {
        await this.getDataSetFile()
      }
      else{
        this.isEDC = true;
        await this.listInterimVersionFiles()
      }
    },
    async getDataSetFile()
    {
      const idtoken = store.getters.getIdToken;
      await axios
      .get(
        `${this.baseurl}/stats-python/general/getversioneddatasetsdb?studyid=${this.studyInfo.studyId}&datasetversion=${this.selectedIntVersion}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        this.dbDatasets = res.data;
        console.log("datasaet list is",this.dbDatasets)
        // this.LocationType = this.dataconfig.
        // console.log("graph list is",this.dataconfig)
      })
      .catch((err) => {
        console.log(err);
      });

    },
    async getTOCDatasetConfig()
    {
      const idtoken = store.getters.getIdToken;
      await axios
      .get(
        `${this.baseurl}/stats-python/toc/gettocdatasetconfig?studyId=${this.studyInfo.studyId}&tocVersion=Base`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        this.dataconfig = res.data.result[0];
        this.LocationType = this.dataconfig.DatasetLocation;
        this.selectedIntVersion = this.dataconfig.DatasetVersion;
        console.log("graph list is",this.dataconfig)
        // this.LocationType = this.dataconfig.
        // console.log("graph list is",this.dataconfig)
      })
      .catch((err) => {
        console.log(err);
      });
    },
    getOperatorOptions(field) {
      if (!field) return ['=='];
      if (this.categoricalFields.includes(field)) {
        return ['==', '!='];
      } else if (this.numericalFields.includes(field)) {
        return ['==', '>', '<', '>=', '<=', '!='];
      }
      return ['==']; // default fallback
    },
    async  columnFilterChange(value) {
      if(this.reportType == 'Table' && this.uniqueField != '' ){
        await this.getFieldValues();
      }
    },
    async uniqueFieldUpdated(){
      if(this.uniqueField == ''){
        this.groupByField = '';
      }
      else{
        await this.getFieldValues();
      }
    },
    async addRow(type, index) {
      if (type == 'row') {
        this.rowFilters.push(
          {
            Operator: "",
            ColumnName: "",
            Value: ""
          }
        )
      }
      else if (type == 'calculations') {
        // Create a unique key like 'frequency_fields1', 'frequency_fields2', etc.
        const key = `frequency_fields`;
        // Add the key with the default object structure
        this.calculations[key] = {
          group_by: [],
          frequency_column: [],
          subject_column: []
        }
      }
      else {
        this.rowTableFilters.push(
          {
            Operator: "",
            ColumnName: "",
            Value: ""
          }
        )
      }console.log("row filters",this.rowFilters)
    },
    async deleteFilter(type, index) {
      if (type == 'row') {
        this.rowFilters.splice(index, 1);
      }
      else if (type == 'calculations') {
        delete this.calculations[index];
        this.counter--
      }
      else
      {
        this.rowTableFilters.splice(index, 1);
      }

    },
    valueChange(){
      this.groupByField = "";
      this.dropdownSelections = {};
      if(this.reportType!='Chart' && this.validations[5]==true){
        this.validations[5]=false
      }
      if(this.reportType=='Graph'){  
        this.getGraphList()
      }
      if(this.reportType !=='Graph' ){
        this.chartType= "";
      }
    },
    async getGraphList()
    {
      const idtoken = store.getters.getIdToken;
      await axios
      .get(
        `${this.baseurl}/stats-python/macro/graphs`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        this.graphList = res.data;
        console.log("graph list is",this.graphList)
      })
      .catch((err) => {
        console.log(err);
      });
    },
    removeField(field) {
      this.columnFieldNames = this.columnFieldNames.filter(f => f !== field);
      delete this.dropdownSelections[field];
    },
    onClearClicked(){
      this.dropdownSelections = {};
    },
    onFilterValueCleard(field) {
      console.log(" on filtr cleared")
      delete this.dropdownSelections[field];
    },
    async setValidations() {
      this.rowFilterValidations[0] = [false, false, false]
      this.validations = [false, false, false, false, false, false, false, false, false, false, false, false, false]
      const fields = [
        { value: this.programName, index: 0 },
        { value: this.LocationType, index: 1 },
        { value: this.location, index: 2 },
        { value: this.selectedIntVersion, index: 3 },
        { value: this.programType, index: 4 },
        { value: this.returnType, index: 5 },
        { value: this.orientation, index: 6 },
        { value: this.reportType, index: 7 },
        { value: this.chartType, index: 8 },
        { value: this.columnFieldNames, index: 9},
        { value: this.groupByField, index: 10},
        { value: this.status, index: 11 },
      ];
       fields.forEach(({ value, index }) => {
        if ((index === 8)&& this.reportType === 'Graph') {
          this.validations[8] = !value;
        } 
        else if((index === 10)&& this.reportType === 'Table') {
          this.validations[10] = !value;
        }
        // else if (index === 3 && this.LocationType == 'datalake') {
        //   this.validations[3] = !value;
        // }
        else if (index !== 8 && index!== 10 &&  index !== 3) {
          if(index === 9){
            this.validations[9] = value.length === 0 ? true : false;
          }
          else if (this.setMacro && index !== 11) {
            this.validations[index] = !value;
          } else if(this.setMacro==false) {
            this.validations[index] = !value;
          }
        }        
      });
      if (this.validations.includes(true) || this.rowFilterValidations.some((error) => error.includes(true)) || this.calculationsFilterValidations.some((error) => error.includes(true))) {
        this.loadingSaveBlock = false
        this.loadingBlock = false
      }
    },
    async validateColumnFilterValues() {
      this.columnErrorList = [];
      console.log("column field names", this.columnFieldNames);
      console.log("dropdown selections", this.dropdownSelections);

      this.columnFieldNames.forEach(element => {
        const values = this.dropdownSelections[element];
        if (Array.isArray(values) && values.length > 0) {
          this.columnErrorList[element] = false;
        } else {
          this.columnErrorList[element] = true;
        }
      });
    },

    async saveMacro(){ 
      const idtoken = store.getters.getIdToken;
      this.columnFieldNames.forEach(field => {
        const selectedValues = this.dropdownSelections[field];
        if (selectedValues && selectedValues.length > 0) {
          columnValueFilters[field] = selectedValues;
        }
      });
      if(this.editoption=='0'){
        await axios
        .post(
          `${this.baseurl}/stats-python/macro/create`,
          {
            "ProgramName": this.programName,
            "ProgramVersion": this.selectedIntVersion,
            "ProgramType" : this.programType,
            "FileName": this.fileName,
            "ReportType": this.reportType,
            "SaveTo": "", // Add this field if needed
            "ChartType": this.chartType,
            "RowFilters": this.rowFilters,
            "ColumnFilters": this.columnFieldNames,
            "ColumnValueFilters": columnValueFilters,
            "UniqueField": this.uniqueField,
            "GroupBy": this.groupByField,
            "IncludeTotal": true,
            "NumericOperations": this.numericOperations,
            "PageGroup": this.pageGroup,
            "ReturnType": this.returnType,
            "Orientation": this.orientation,
            "Projection": "", // Add this field if needed
            "Sorting": {}, // Add this field if needed
            "Table": this.reportType == 'Table' ? [
              {
                "ProgramName": this.programName,
                "RowFields": this.tableRowFieldNames,
                "ColumnFields": this.tableColumnFieldNames,
                "ColumnFilters": this.columnFieldNames,
                "RowFilters": this.rowFilters,
                "GroupBy": this.groupByField,
                "IncludeTotal": true,
                "PageGroup": this.pageGroup,
                "ReturnType": this.returnType,
                "ReportType": this.reportType,
                "Orientation": this.orientation,
                "Title": this.tableTitle,
                "Subtitle": this.tableSubtitle,
                "Footnote": this.footnotes
              }
            ] : [],
            "StudyRef": this.studyInfo.studyRef,
            "TocDescription": "", // Add this field if needed
            "MongoCollection": this.mongoCollection,
            "InterimVersion": this.interimVersion,
            "LocationType": this.LocationType,
            "Location": this.location,
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.loadingSaveBlock = false
          if (this.editoption == '0') {
            alert(this.$t('navigations.macro created successfully'))
            this.$router.push('/Macro_Management')
          }
          if (this.editoption == '1') {
            alert(this.$t('navigations.macro updated successfully'))
          }
        })
        .catch((err) => {
          this.loadingSaveBlock = false
        });
      }
      else if(this.editoption=='1'){
        await axios
        .put(
         `${this.baseurl}/stats-python/macro/update`,
          
            {
              "Id": this.id,
              "ProgramName": this.programName,
              "ProgramVersion": this.selectedIntVersion,
              "ProgramType" : this.programType,
              "FileName": this.fileName,
              "ReportType": this.reportType,
              "SaveTo": "",
              "ChartType": this.chartType,
              "RowFilters": this.rowFilters,
              "ColumnFilters": this.columnFieldNames,
              "GroupBy": this.groupByField,
              "IncludeTotal": true,
              "NumericOperations": this.numericOperations,
              "PageGroup": this.pageGroup,
              "ReturnType": this.returnType,
              "Orientation": this.orientation,
              "UniqueField":this.uniqueField,
              "Projection": "",
              "Sorting": {
                "additionalProp1": "",
                "additionalProp2": "",
                "additionalProp3": ""
              },
              "Table":this.reportType=='Table' ? [
                {
                  "ProgramName": this.programName,
                  "RowFields": this.tableRowFieldNames,
                  "ColumnFields":this.tableColumnFieldNames,
                  "IncludeTotal": true,
                  "Title": this.tableTitle,
                  "Subtitle": this.tableSubtitle,
                  "Footnote": this.footnotes
                }
              ] : [],
              "StudyRef": this.studyInfo.studyRef,
              "TocDescription": "",
              "MongoCollection": this.mongoCollection,
              "InterimVersion": this.interimVersion
            }
         ,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.loadingSaveBlock = false
          if (this.editoption == '0') {
            alert(this.$t('navigations.macro created successfully'))
            this.$router.push('/Macro_Management')
          }
          if (this.editoption == '1') {
            alert(this.$t('navigations.macro updated successfully'))
            this.$router.push('/Macro_Management')
          }
        })
        .catch((err) => {
          this.loadingSaveBlock = false
        });
      }      
    },
    async saveData() {
      this.loadingSaveBlock = true
      await this.setValidations() 
      if(this.uniqueField != null && this.uniqueField != '' && this.reportType == 'Table'){
        await this.validateColumnFilterValues();
      }
      console.log("column error list",this.columnErrorList);
      if (!this.validations.includes(true) && 
          !Object.values(this.columnErrorList).some(v => v === true)&& 
          !this.rowFilterValidations.some((error) => error.includes(true)) && 
          !this.calculationsFilterValidations.some((error) => error.includes(true)))
      {
        const idtoken = store.getters.getIdToken;
        await this.updateArray()
        if(this.setMacro==true || this.setMacro=='true')
          {
              this.saveMacro()          
          }
        else{
          const columnValueFilters = {};
          if(this.reportType=='Table'){
            this.columnFieldNames.forEach(field => {
              const selectedValues = this.dropdownSelections[field];
              if (selectedValues && 
                  this.uniqueField != "" &&
                  ((typeof selectedValues === 'string' && selectedValues.length > 0) || 
                  (Array.isArray(selectedValues) && selectedValues.length > 0) || 
                  (typeof selectedValues === 'number' && !isNaN(selectedValues)))) {
                columnValueFilters[field] = selectedValues;
              }
            });
          }
          await axios
          .post(
            `${this.baseurl}/stats-python/programme/createprogram`,
            {
              "StudyId":this.studyInfo.studyId,
              "StudyName": this.studyInfo.studyName,
              "StudyRef": this.studyInfo.studyRef,
              "TocId": this.tocId,
              "ReportId": this.reportId,
              "ReportName": this.reportName,
              "TocDescription": "",
              "DeveloperName": this.developerName,
              "QCName":this.qcName,
              "Status": this.status,
              "MacroId": "",
              "SourceId": this.editoption=='1'? this.editData._id:"",
              "IsSelectedVersion": true,
              "ProgramName": this.programName,
              "ProgramVersion": this.selectedIntVersion,
              "ProgramType" : this.programType,
              "FileName": this.fileName,
              "RowFilters": this.rowFilters,
              "ColumnFilters":this.columnFieldNames,
              "ColumnValueFilters": columnValueFilters,
              "UniqueField":this.uniqueField,
              "ReportType": this.reportType,
              "SaveTo":"",
              "ChartType": this.chartType,
              "GroupBy": this.groupByField,
              "IncludeTotal": true,
              "NumericOperations": this.numericOperations,
              "PageGroup": this.pageGroup,
              "ReturnType": this.returnType,
              "Orientation": this.orientation,
              "Projection": "",
              "Sorting": {
              },
              "Table": this.reportType=='Listing' ? [
                {  
                  "ProgramName": this.programName,
                  "RowFields": this.tableRowFieldNames,
                  "ColumnFields":this.tableColumnFieldNames,
                  "IncludeTotal": true,
                  "Title": this.tableTitle,
                  "Subtitle": this.tableSubtitle,
                  "Footnote":this.footnotes,
                  "CreatedTime": "2025-01-09T12:00:00Z"
                }
              ]:[],
                "Comments": this.comments,
                "LocationType": this.LocationType ,
                "Location": this.location,
                "MongoCollection": this.mongoCollection,
                "InterimVersion": this.interimVersion
            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            this.loadingSaveBlock=false
            if(this.editoption=='0'){
              alert(this.$t('navigations.program created successfully'))
            } 
            if(this.editoption=='1'){
              alert(this.$t('navigations.program updated successfully'))
            }
            this.validations= [false, false, false, false, false, false, false, false, false, false, false, false, false]
            this.$router.push(`/tocgenerate`)
          })
          .catch((err) => {
            this.loadingSaveBlock = false
          }); 
        }
  
      }
      else{
        console.log("validations:-",this.validations," row filter validations:-",this.rowFilterValidations, "calculations filter validations:-", this.calculationsFilterValidations, "columnErrorList:-", this.columnErrorList);
        this.loadingSaveBlock = false;
      }
    },
    setVersionNo(){
      store.dispatch("setVersion",this.interimVersion)
    },
    async getVersion(){
      const idtoken = store.getters.getIdToken;
       await axios.get(
        `${this.baseurl}/forms/cdisc/listinterimversions?studyId=${this.studyInfo.studyId}`,
        {
          headers: {
            Authorization: `Bearer ${idtoken}`,
            "Content-Type": "application/json",
          },
        }
      ).then((res)=>{
          this.versionList = res.data
                  
      }).catch((err)=>{
        console.log("err",err)
      })
    },
    async getGraphData() {
      this.loadingBlock = true
      await this.setValidations();
      if (!this.validations.includes(true) && !this.rowFilterValidations.some((error) => error.includes(true)) && !this.calculationsFilterValidations.some((error) => error.includes(true)))
        {
      const idtoken = store.getters.getIdToken;
      await this.updateArray()
      await axios
        .post(
          `${this.baseurl}/stats-python/macro/view`,
          {

            "ProgramName": this.programName,
            "FileName": this.fileName,
            "RowFilters": this.rowFilters,
            "ColumnFilters":
              this.columnFieldNames
            ,
            "ReportType": this.reportType,
            "GroupBy": this.groupByField,
            "IncludeTotal": true,
            "NumericOperations":this.numericOperations,
            "PageGroup": this.pageGroup,
            "ReturnType": this.returnType,
            "Orientation": this.orientation,
            "Projection": "",
            "ChartType":this.chartType,
            "Sorting": {
            },
            "Table": this.reportType=='Table' ? [
              {  
                "ProgramName": this.programName,
                "RowFields": this.tableRowFieldNames,
                "ColumnFields":this.tableColumnFieldNames,
                "IncludeTotal": true,
                "Title": this.tableTitle,
                "Subtitle": this.tableSubtitle,
                "Footnote":this.footnotes,
                "CreatedTime": "2025-01-09T12:00:00Z"
              }
            ]:[]
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.dataPages = res.data;
          this.dataPages.forEach((eachitem) => {
            eachitem.Value = this.hexToUtf8(eachitem.Value);
          })
          this.displayModal = true
          this.loadingBlock = false

        })
        .catch((err) => {
          this.loadingBlock = false
          this.validations = [false, false, false, false, false, false, false]

        });
      }
    },
    async exBtnClicked() {
      await this.getGraphData()
      await this.$nextTick();
      this.dataPages.forEach((eachitem,index) => {
         this.loadIframeContent(`${eachitem.Page}-${index}`, eachitem.Value)
      })
    },
    async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
          await axios
        .get(
          `${this.baseurl}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getData(){
      const idtoken = store.getters.getIdToken;
      if(this.setMacro == true && this.editoption=='1'){
        await axios
        .get(
          `${this.baseurl}/stats-python/macro/macro/${this.id}`,
          
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          this.editData=res.data
          this.studyInfo.studyId=this.editData.studyId!=''?this.editData.StudyId:''
          this.studyInfo.studyName=this.editData.StudyName!=''?this.editData.StudyName:''
          this.studyInfo.studyRef=this.editData.StudyRef!=''?this.editData.StudyRef:''
          this.tocId=this.editData.TocId!=''?this.editData.TocId:''
          this.reportId=this.editData.ReportId!=''?this.editData.ReportId:''
          this.reportName=this.editData.ReportName!=''?this.editData.ReportName:''
          this.developerName=this.editData.DeveloperName!=''?this.editData.DeveloperName:''
          this.qcName=this.editData.QCName!=''?this.editData.QCName:''
          this.status=this.editData.Status!=''?this.editData.Status:''
          this.programId=this.editData.ProgramId!=''?this.editData.ProgramId:''
          this.programName=this.editData.ProgramName!=''?this.editData.ProgramName:''
          this.programType=this.editData.ProgramType!=''?this.editData.ProgramType:''
          this.selectedIntVersion = this.editData.ProgramVersion!=''?this.editData.ProgramVersion:'',
          this.isEDC = this.editData.ProgramVersion !='' ? true : false;
          this.fileName=this.editData.FileName!=''?this.editData.FileName:''
          this.mongoCollection=this.editData.MongoCollection!='' && this.editData.MongoCollection!=null ? this.editData.MongoCollection:''
          this.rowFilters=this.editData.RowFilters!=''?this.editData.RowFilters:[]
          this.columnFieldNames=this.editData.ColumnFilters!=''?this.editData.ColumnFilters:[]
          this.reportType=this.editData.ReportType!=''?this.editData.ReportType:''
          this.groupByField=this.editData.GroupBy!=''?this.editData.GroupBy:''
          this.chartType=this.editData.ChartType!=''?this.editData.ChartType:''
          this.uniqueField = this.editData.UniqueField!=''?this.editData.UniqueField:''
          this.dropdownSelections = this.editData.ColumnValueFilters || {};
          this.numericOperations=this.editData.NumericOperations!=''?this.editData.NumericOperations:[]
          this.returnType=this.editData.ReturnType!=''?this.editData.ReturnType:''
          this.orientation=this.editData.Orientation!=''?this.editData.Orientation:''
          this.pageGroup=this.editData.PageGroup!=''?this.editData.PageGroup:''
          if (this.editData.InterimVersion !== '' && this.editData.InterimVersion !== undefined) {
            store.dispatch('setVersion', this.editData.InterimVersion);
            this.interimVersion = this.editData.InterimVersion;
          } else {
            this.interimVersion = store.getters.getVersion;
          }
          if(this.reportType == 'Graph'){
            await this.getGraphList()
          }
        })
        .catch((err) => {
          this.loadingSaveBlock = false
        })
      }
      else if(this.setMacro == false && this.editoption=='1'){
        await axios
        .get(
          `${this.baseurl}/stats-python/programme/getprogrambyid/${this.id}`,
          
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          this.editData=res.data
          this.LocationType = this.editData.LocationType || "database";
          this.location = this.editData.Location || "";
          this.studyInfo.studyId=this.editData.studyId!=''?this.editData.StudyId:''
          this.studyInfo.studyName=this.editData.StudyName!=''?this.editData.StudyName:''
          this.studyInfo.studyRef=this.editData.StudyRef!=''?this.editData.StudyRef:''
          this.tocId=this.editData.TocId!=''?this.editData.TocId:''
          this.reportId=this.editData.ReportId!=''?this.editData.ReportId:''
          this.reportName=this.editData.ReportName!=''?this.editData.ReportName:''
          this.developerName=this.editData.DeveloperName!=''?this.editData.DeveloperName:''
          this.qcName=this.editData.QCName!=''?this.editData.QCName:''
          this.status=this.editData.Status!=''?this.editData.Status:''
          this.programId=this.editData.ProgramId!=''?this.editData.ProgramId:''
          this.programName=this.editData.ProgramName!='' ? this.editData.ProgramName :''
          this.programType=this.editData.ProgramType!='' ? this.editData.ProgramType :''
          this.selectedIntVersion = this.editData.ProgramVersion!='' ? this.editData.ProgramVersion :''
          this.isEDC = this.editData.ProgramVersion !='' ? true : false;
          this.fileName=this.editData.FileName!='' && this.editData.FileName!= null ?this.editData.FileName:''
          this.mongoCollection=this.editData.MongoCollection!='' && this.editData.MongoCollection!=null ? this.editData.MongoCollection:''
          this.rowFilters=this.editData.RowFilters!=''?this.editData.RowFilters:[]
          this.columnFieldNames=this.editData.ColumnFilters !=''?this.editData.ColumnFilters:[]
          this.reportType=this.editData.ReportType!=''?this.editData.ReportType:''
          this.groupByField=this.editData.GroupBy!=''?this.editData.GroupBy:''
          this.chartType=this.editData.ChartType!=''?this.editData.ChartType:''
          this.numericOperations=this.editData.NumericOperations!=''?this.editData.NumericOperations:[]
          this.dropdownSelections = this.editData.ColumnValueFilters || {};
          this.uniqueField=this.editData.UniqueField!=''?this.editData.UniqueField:''
          this.pageGroup=this.editData.PageGroup!=''?this.editData.PageGroup:''
          this.returnType=this.editData.ReturnType!=''?this.editData.ReturnType:''
          this.orientation=this.editData.Orientation!=''?this.editData.Orientation:''
          if (this.editData.InterimVersion !== '' && this.editData.InterimVersion !== undefined) {
            store.dispatch('setVersion', this.editData.InterimVersion);
            this.interimVersion = this.editData.InterimVersion;
          } else {
            this.interimVersion = store.getters.getVersion;
          }
          if(this.reportType == 'Graph'){
            await this.getGraphList()
          }
        })
        .catch((err) => {
          this.loadingSaveBlock = false
        })
      }
   
    },
    adjustIframeWidth(event,page) {
      const iframe = document.getElementById(page);
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;

      if (iframeDocument && iframeDocument.body) {
        // Get the content's width
        const contentWidth = iframeDocument.body.scrollWidth;
        if(contentWidth>300){
          iframe.style.width = `${contentWidth}px`;
        }
        
      }
    },
    loadIframeContent(page, value) {
      const iframe = document.getElementById(page);
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(value);
      doc.close();
    },
    hexToUtf8(hexString) {
      // Ensure the hex string is properly formatted by removing spaces and any extra characters
      hexString = hexString.replace(/\s+/g, '');

      // Convert each pair of hex digits to a character and join them into a string
      let utf8String = '';
      for (let i = 0; i < hexString.length; i += 2) {
        const hexCode = hexString.substr(i, 2);
        utf8String += String.fromCharCode(parseInt(hexCode, 16));
      }

      return utf8String;
    },
    async updateArray() {
      if (this.rowFilters.length > 0) {
        this.rowFilters.forEach((item) => {
          if (item.Value) {
            if (!isNaN(item.Value)) {
              if (item.Value && String(item.Value).trim() !== '') {
                item.Value = parseFloat(item.Value); // Parse to number
              }
            } else {
              item.Value = item.Value.toString(); // Keep as string
            }
          }
        })
      }
    },
    closeScreen(){
      if(this.setMacro==false){
        this.$router.push(`/tocgenerate`)
      }
      else{
        this.$router.push('/Macro_Management')
      }
      
    },
     async getUserList() {
          const idtoken = store.getters.getIdToken;
          await axios
            .get(
              `${this.baseurl}/account-core/user/getstudyuserbasic?studyid=${store.getters.getStudyIs}&api-version=1.0`,
              {
                headers: {
                  Authorization: "Bearer " + idtoken,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((res) => {
               this.userList = (res.data.entities || []).map(user => ({
        ...user,
        fullName: `${user.firstName} ${user.lastName}`
      }));
            })
            .catch((err)=>{
              console.log(err)
            })
    },
    async locationChanged(){
      this.fileName = '';
      this.location = '';
      if(this.LocationType == 'database'){
        this.interimVersions = [];
        this.interimVersionFiles = [];
        this.selectedIntVersion = '';

        await this.listDbDatasets();
      }
      else if(this.LocationType == 'datalake'){
        this.dbDatasets = [];
        await this.listInterimVersions();
      }
    },
     async getFieldsOne (location){
      await this.listFieldNames();
    },
    async listDbDatasets(){
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/getversionedadamsetsdb?studyid=${this.studyInfo.studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.dbDatasets = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async listFieldNames(){
      const idtoken = store.getters.getIdToken;
      var parameter = '';
      if(this.LocationType == 'database'){
         var fileName = this.location.split("-");
         parameter = `studyId=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${fileName[0]}&threshold=10&interimver=${fileName[1]}`
      }
      else if(this.LocationType == 'datalake'){
         parameter = `studyId=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${this.location}&threshold=10&interimver=${this.selectedIntVersion}`
      }
      
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/fields2?${parameter}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        const cat = res.data.categorical || [];
        const num = res.data.numerical || [];

        this.categoricalFields = cat;
        this.numericalFields = num;
        this.rowFilterFields = [...cat, ...num].sort((a, b) => a.localeCompare(b));
        // this.rowFilterFields = [...res.data.categorical, ...res.data.numerical].sort((a, b) => {
        //     if (a < b) return -1;
        //     if (a > b) return 1;  
        //     return 0;            
        // });
        this.columnFilters = [...res.data.categorical, ...res.data.numerical].sort((a, b) => {
          if (a < b) return -1; 
          if (a > b) return 1;  
          return 0;             
        });
        this.groupByFilter = res.data.categorical.sort((a, b) => {
          if (a < b) return -1; 
          if (a > b) return 1; 
          return 0;
        });
        this.columnFiltersValues= this.columnFilters.map(field => ({ label: field, value: field }));
      } catch (err) {
        console.log(err);
      }
    },
    async getFieldValues(){
      const idtoken = store.getters.getIdToken;
      var parameter = '';
      if(this.LocationType == 'database'){
         var fileName = this.location.split("-");
         parameter = `studyid=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${fileName[0]}&interimversion=${fileName[1]}&threshold=10 `
      }
      else if(this.LocationType == 'datalake'){
         parameter = `studyid=${this.studyInfo.studyId}&datalocation=${this.LocationType}&fileName=${this.location}&interimversion=${this.selectedIntVersion}&threshold=10 `
      }
      try {
        var fileName = this.location.split("-");
        const res = await axios.put(
        `${this.baseurl}/stats-python/general/fieldvalues2?${parameter}`,
          this.columnFieldNames,
          {
            headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
            },
          }
        );
        this.fieldValues = res.data;
      } catch (err) {
        console.log(err);
      }
    },
    async listInterimVersions() {
      try{
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(`${this.baseurl}/stats-python/general/getadamdatalakeinterimversions?StudyId=${this.studyInfo.studyId}`,
          {
            headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
            }
          });
        this.interimVersions= res.data;
      }
      catch (err) { console.log(err); }
    },
    async changeInterimVersion(){
      this.location = '';
      console.log("selected interim version",this.selectedIntVersion);
      if(this.selectedIntVersion == '' || this.selectedIntVersion == null){
        this.isEDC = false;
      }
      else{
       this.isEDC = true;
      }
       console.log("Is EDC",this.isEDC);
      await this.listInterimVersionFiles();
    },
    async listInterimVersionFiles() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/stats-python/general/getversionfiles?StudyId=${this.studyInfo.studyId}&interimversion=${this.selectedIntVersion}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("interim version files rrrr", res.data[0]);
        this.interimVersionFiles = res.data[0];  
      } catch (err) {
        console.log(err);
      }
    }
  }
}
